import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';


const SignupStatusPage = () => {
  const { status } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get('message');
    const isResumeLogin = location.pathname === "/candidate_signup/success" || location.pathname === "/candidate_signup/failed";

  const isSuccess = status === 'success';

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-white shadow-md rounded-md p-6 max-w-md w-full text-center">
        <div className="flex flex-col items-center gap-2">
          {isSuccess ? (
            <>
              <FaCheckCircle className="mph-primary text-3xl" />
              <h2 className="text-lg font-semibold mph-primary">Signup Successful!</h2>
              <p className="text-sm text-gray-666">
                Your account has been created. Please login with your credentials.
              </p>
            </>
          ) : (
            <>
              <FaTimesCircle className="text-red-500 text-3xl" />
              <h2 className="text-lg font-semibold text-red-600">Signup Failed</h2>
              <p className="text-sm text-gray-666">
                {message || 'Something went wrong. Please try again later.'}
              </p>
            </>
          )}
        </div>

        <Link
           to={isResumeLogin ? "/resume-login" : "/login"}
          className="mt-6 inline-block bg-gradient text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:shadow-lg"
        >
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default SignupStatusPage;
